module.exports = __webpack_public_path__ + "static/media/red-number-8.a806ec5d.png";